'use client'

import { ConfirmDialog } from '@macarongfactory/web-ui'
import { useEffect, useRef } from 'react'

import {
  MODOOCAR_CODE,
  OWNER_REVIEW_WRITE_DEEPLINK,
  useModoocarTracking,
} from '../_features/modoocar'

interface IReviewPromptDialogProps {
  open: boolean
  onClose: () => void
}

const ReviewPromptDialog = ({ open, onClose }: IReviewPromptDialogProps) => {
  const { itemShow, itemClick } = useModoocarTracking()
  const shownRef = useRef(false)
  useEffect(() => {
    if (!open || shownRef.current) return
    shownRef.current = true
    itemShow(MODOOCAR_CODE.REVIEW_PROMPT, 'dialog', '오너 리뷰 작성 안내')
  }, [open, itemShow])

  const handleLater = () => {
    itemClick(MODOOCAR_CODE.REVIEW_PROMPT, 'button', '나중에')
    onClose()
  }
  const handleWrite = () => {
    itemClick(MODOOCAR_CODE.REVIEW_PROMPT, 'button', '작성하기')
    // [앱]: iOS WKWebView에서 onClose와 같은 틱에 location.href로 커스텀 스킴을 열면 이동이 무시됩니다.
    // 그래서 실제 <a> 클릭으로 앱을 먼저 연 뒤 닫습니다.
    const anchor = document.createElement('a')
    anchor.href = OWNER_REVIEW_WRITE_DEEPLINK
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
    onClose()
  }

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      className='[&_section>div]:!pb-dimension-x4'
      top={
        <ConfirmDialog.Top.LeftAlignedHeader
          title='내 차 리뷰를 남겨주세요'
          description='리뷰를 남기시면 더 많은 오너들의 리뷰를 확인할 수 있어요.'
          className='break-keep'
        />
      }
      bottom={
        <ConfirmDialog.Bottom.BottomCTA.Horizontal
          subButton={
            <ConfirmDialog.Bottom.SubButton.SolidButton
              text='나중에'
              onClick={handleLater}
            />
          }
          mainButton={
            <ConfirmDialog.Bottom.MainButton.SolidButton
              text='작성하기'
              onClick={handleWrite}
            />
          }
        />
      }
    />
  )
}

export default ReviewPromptDialog
